import { useState, useEffect, useMemo, useCallback } from "react";
import { Dropdown } from "antd";
import type { MenuProps } from "antd";
import "./customStyle.css";
import { LoadingOutlined } from "@ant-design/icons";
import {
  useUpdateLessonCompleteStatusMutation,
  LessonFragmentDoc,
  useGetUnitLazyQuery,
  useHeaGetUnitInfoLazyQuery,
  useHeaUpdateLessonStatusMutation,
  StudyPlanContentFragment,
  useFeedbackFormLazyQuery,
  useCancelFeedbackFormMutation,
  Content,
} from "@api/graphql-codegen";
import styles from "./LessonForm.module.scss";
import {
  ExitTicketActive,
  Lesson,
  LessonStatus,
  ModeTypeEnum,
} from "../../../types";
import NormalCheckIcon from "../../../assets/icons/mark_check_normal.svg?react";
import MarkCheckIcon from "../../../assets/icons/mark_check.svg?react";
import InprogressIcon from "../../../assets/icons/mark_inprogress.svg?react";
import MarkCrossIcon from "src/assets/icons/cross_circle_filled.svg?react";
import ConnectIcon from "src/assets/icons/arrow_connect.svg?react";
import CompleteConnectIcon from "src/assets/icons/arrow_connect_complete.svg?react";
import MisconnectIcon from "src/assets/icons/arrow_misconnect.svg?react";
import InCompleteConnectIcon from "src/assets/icons/arrow_misconnect_incomplete.svg?react";
import DisconnectIcon from "src/assets/icons/arrow_prerequisite.svg?react";
import BurgerIcon from "src/assets/icons/burger.svg?react";
import TicketIcon from "src/assets/icons/ticket.svg?react";
import OutlineIcon from "src/assets/icons/outline.svg?react";
import WarningIcon from "src/assets/icons/warning-red1.svg?react";
import CheckIcon from "src/assets/icons/complete_check.svg?react";
import CloseIcon from "src/assets/icons/complete_uncheck.svg?react";
import ShareIcon from "src/assets/icons/new-share.svg?react";
// import InformIcon from 'src/assets/icons/red-warning.svg?react';
import CompleteLock from "src/assets/icons/lock-complete.svg?react";
import PreviewLock from "src/assets/icons/lock-preview.svg?react";
import CompleteLockRed from "src/assets/icons/lock-complete-red.svg?react";
import PreviewLockRed from "src/assets/icons/lock-preview-red.svg?react";
import IconOutline from "src/assets/icons/new-outline-info.svg?react";
import IconArrowUp from "src/assets/icons/dropdown-white.svg?react";
import { getMediaAbsolutePath } from "../../../services/File";
import Button from "@src/components/button/Button";
import { useToast } from "@hooks/useToast";
import {
  useAnalytics,
  Events,
  useCourseContent,
  useExitTicketLocalStorage,
} from "@hooks";
import {
  IconInfo,
  IconRateLesson,
  isHomeEDApp,
  StudentWellBeingSurveyId,
  SURVEY_TYPE,
} from "@constants";
import Tooltip from "antd/es/tooltip";
import Spinner from "@src/components/spinner/Spinner";
import ReviewImg from "src/assets/img/review.svg?react";
import { Menu } from "antd";
import { CopyToClipboard, Collapse } from '@src/utils/componentCasts';
import MaterialCard from "@src/components/materialCard/Card";
import { useLessonFeedbackStatusStorage } from "@src/hooks/useLessonFeedbackStatusStorage";
import { LordIcon } from "@src/components/lord-icon/lord-icon";
import { hasArrayValues } from "@src/utils/helpers";
import { logger } from "../../../utils/logger";

const CollapseComponent = Collapse as React.ComponentType<any>;
const CopyToClipboardComponent = CopyToClipboard as React.ComponentType<any>;

type Props = {
  lesson: Lesson;
  index: number;
  lessonCount: number;
  preLesson?: Lesson;
  nextLesson?: Lesson;
  openDetails: (lesson: Lesson) => void;
  openStudyPlanDetails: (
    lesson: Lesson,
    plan: StudyPlanContentFragment,
  ) => void;
  openPreview: (lesson: Lesson) => void;
  openTeacherFeedback: (lesson: Lesson) => void;
  unitId: string;
  lessonInfo: {
    unit_name: string | undefined;
    unit_id: string | undefined;
    course_name: string | undefined;
    course_id: string | undefined;
    lesson_name: string | undefined;
    lesson_id: string | undefined;
    lesson_position: number | 0;
    schoolId: string | undefined;
    schoolName: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
  };
  isParentApp?: boolean;
  isLocked?: boolean;
  studyPlansForSelectedUnit?: StudyPlanContentFragment[];
  studyPlan?: StudyPlanContentFragment;
  getHeaLessonCompletedStatus?: () => void;
  getHeaLessonStatusLoading?: boolean;
  openLessonWithChilds?: (lesson: Lesson) => void;
  studyMode?: string;
  isParentUnit?: boolean;
  handleGenerateTicket?: (lesson: Lesson) => void;
  handleCancelExitTicket?: (lesson: Lesson) => void;
  exitTicket?: ExitTicketActive;
  movedScroll?: boolean;
  isOnlyNotCompletedLesson?: boolean;
  openConfirmPassword: (lesson: Lesson) => void;
  preRequiredLessonNumbers?: number[];
  incompleted?: boolean;
  openExitTicket?: (
    lesson: Lesson,
    studyPlan: StudyPlanContentFragment,
  ) => void;
  reviewNow?: (lesson: Lesson) => void;
  reviewLesson?: (lesson: Lesson, studyPlan: StudyPlanContentFragment) => void;
  confirmNow?: (lesson: Lesson, studyPlan: StudyPlanContentFragment) => void;
  lessonConfirming?: boolean;
  openAppravalPendingModal?: () => void;
  handleResumeMenu?: (lesson: Lesson) => void;
  handleStartBeginMenu?: (lesson: Lesson) => void;
  unitUniqueName?: string | null;
  handleDownloadMaterial?: (
    content: Content,
    lesson: Lesson,
    needPrint?: boolean,
  ) => void;
  showMaterailView?: boolean;
  handleOpenShareModal: (lesson: Lesson) => void;
};

const createURL = (id: string) => {
  return `${window.location.origin}/ff/${id}`;
};

function getInCompleteLessons(lessons: any[]) {
  const inCompleted = lessons
    .filter((e) => e?.status !== "completed")
    .map((lesson) => {
      return lesson.number;
    });
  if (inCompleted.length > 0) {
    const replaceIndex = inCompleted.toString().length - 2;
    const replaceText = inCompleted
      .toString()
      .substring(replaceIndex, inCompleted.toString().length);
    const lastLesson = inCompleted
      .toString()
      .substring(replaceIndex + 1, inCompleted.toString().length);
    return inCompleted.toString().replace(replaceText, ` and ${lastLesson}`);
  }
  return "";
}
function LessonForm(props: Props) {
  const {
    lesson,
    index,
    lessonCount,
    preLesson,
    nextLesson,
    openDetails,
    openLessonWithChilds,
    openPreview,
    openTeacherFeedback,
    unitId,
    lessonInfo,
    isParentApp,
    isLocked = false,
    studyPlansForSelectedUnit,
    studyPlan,
    getHeaLessonCompletedStatus,
    getHeaLessonStatusLoading,
    studyMode,
    isParentUnit = false,
    handleGenerateTicket,
    handleCancelExitTicket,
    exitTicket,
    movedScroll,
    isOnlyNotCompletedLesson,
    // openConfirmPassword,
    preRequiredLessonNumbers,
    incompleted,
    openExitTicket,
    reviewNow,
    reviewLesson,
    confirmNow,
    openAppravalPendingModal,
    handleResumeMenu,
    handleStartBeginMenu,
    handleDownloadMaterial,
    showMaterailView,
    handleOpenShareModal,
  } = props;
  const { successToast } = useToast();
  const {
    name,
    image,
    number,
    duration,
    descriptionHeading,
    descriptionAnswers,
    prerequisite,
    status,
    progress,
    sensitive,
    sensitiveTooltip,
  } = lesson;

  const [box, setBox] = useState<string[]>([]);
  const [isHovered, setIsHovered] = useState(false);
  const [completeRequire, setCompleteRequire] = useState(false);
  const [complete, setComplete] = useState(false);
  const [inprogress, setInprogress] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showExitTicketMenu, setShowExitTicketMenu] = useState(false);
  // const [showExitTicketActiveMenu, setShowExitTicketActiveMenu] = useState(false);
  const [showCompleteOptionMenu, setShowCompleteOptionMenu] = useState(false);
  const [selectMaterial, setSelectMaterial] = useState(false);
  const [selectedLessonId, setSelectedLessonId] = useState<string | undefined>(
    undefined,
  );

  const { trackEvent } = useAnalytics();
  const {
    exitTickets,
    setExitTickets,
    currentUnit,
    currentHeaUnit,
    lesson: completeLesson,
    confirmedPassword,
    setConfirmedPassword,
    setLesson,
    program,
    currentStudyplan,
  } = useCourseContent();
  const { getFormId, removeFormId } = useExitTicketLocalStorage();
  const {
    getFeedbackStatusWithLesson,
    setFeedbackStatusWithLesson,
    removeFeedbackStatusWithLesson,
  } = useLessonFeedbackStatusStorage();
  const [rateHover, setRateHover] = useState(false);

  const isRequire = useMemo(
    () => !!preRequiredLessonNumbers?.length,
    [preRequiredLessonNumbers?.length],
  );
  const [feedbackForm, { loading: feedbackLoading }] = useFeedbackFormLazyQuery(
    {
      fetchPolicy: "network-only",
      onCompleted(res) {
        if (res.feedbackForm) {
          const tickets = exitTickets.map((ticket) => {
            if (number === ticket.lessonNum) {
              const currentTime = new Date().getTime();
              const expiration = parseInt(
                res.feedbackForm?.expirationAt ?? "0",
              );
              const url = createURL(res.feedbackForm!.link ?? "");
              const ticketCount = res.feedbackForm?.exitTicketCount ?? 0;
              const expiryMins = (expiration - currentTime) / 1000;

              if (expiryMins > 0) {
                return {
                  ...ticket,
                  status: true,
                  exitTicketCount: ticketCount,
                  expiryMinutes: expiryMins,
                  copyLink: url,
                  code: res.feedbackForm?.link ?? "",
                };
              } else {
                return {
                  ...ticket,
                  status: false,
                  exitTicketCount: 0,
                  expiryMinutes: 0,
                  copyLink: "",
                  code: "",
                };
              }
            }
            return ticket;
          });
          setExitTickets(tickets);
        }
      },
      onError(e) {
        const errorMessage = e?.message || e?.graphQLErrors?.[0]?.message;
        if (errorMessage?.includes("QR code already expired.")) {
          removeFormId(lesson.id);
          const tickets = exitTickets.map((ticket) => {
            if (lesson?.number === ticket.lessonNum) {
              return {
                ...ticket,
                status: false,
                exitTicketCount: 0,
                expiryMinutes: 0,
                copyLink: "",
                code: "",
              };
            }
            return ticket;
          });
          setExitTickets(tickets);
        }
      },
    },
  );
  const formId = getFormId(lesson.id);

  useEffect(() => {
    if (showMaterailView && completeLesson) {
      // Selected Lesson
      setSelectMaterial(true);
      setSelectedLessonId(completeLesson.id);
    }
  }, [showMaterailView, completeLesson]);

  useEffect(() => {
    if (formId) {
      feedbackForm({
        variables: {
          input: { id: formId },
        },
      });
    }
  }, [formId, feedbackForm]);

  useEffect(() => {
    if (status === LessonStatus.Completed && !isHomeEDApp) {
      setComplete(true);
    } else if (status === LessonStatus.Confirmed && isHomeEDApp) {
      setComplete(true);
    } else if (status === LessonStatus.InProgress) {
      setInprogress(true);
    } else {
      setComplete(false);
      setInprogress(false);
    }
  }, [status]);

  useEffect(() => {
    if (movedScroll) {
      setShowMenu(false);
      setShowExitTicketMenu(false);
      // setShowExitTicketActiveMenu(false)
      setShowCompleteOptionMenu(false);
    }
  }, [movedScroll]);

  const [getUnitInfo, { loading: fetching }] = useGetUnitLazyQuery({
    fetchPolicy: "network-only",
  });
  const [heaGetUnitInfo, { loading: fetchingHea }] = useHeaGetUnitInfoLazyQuery(
    { fetchPolicy: "network-only" },
  );
  const [updateLessonComplete, { loading }] =
    useUpdateLessonCompleteStatusMutation({
      onError(e) {
        logger.debug(`[e]`, e);
      },
      onCompleted() {
        if (isHomeEDApp) {
          heaGetUnitInfo({
            variables: { input: { id: unitId } },
          });
        } else {
          getUnitInfo({
            variables: { input: { id: unitId } },
          });
        }
      },
      update(cache, res, { variables }) {
        const d = res.data?.updateLessonCompleteStatus;
        if (d && lesson?.id) {
          cache.updateFragment(
            {
              id: `Lesson:${lesson?.id}`,
              fragment: LessonFragmentDoc,
              fragmentName: "Lesson",
            },
            (l) => ({
              ...l,
              status: variables?.input.status,
            }),
          );
          if (variables?.input.status === LessonStatus.Completed) {
            if (
              lessonInfo.unit_name === "Educator Onboarding" ||
              lessonInfo.unit_name === "Educator Wellbeing"
            ) {
              const courseName =
                lessonInfo?.unit_name === "Educator Onboarding"
                  ? "Educator Onboarding"
                  : lessonInfo?.unit_name === "Educator Wellbeing"
                    ? "Educator Wellbeing"
                    : "";
              const updatedTrackData = {
                ...lessonInfo,
                course_name: courseName,
              };
              trackEvent(Events.actions.lessonCompleted, {
                ...updatedTrackData,
                type: "Unit",
              });
            } else {
              trackEvent(Events.actions.lessonCompleted, {
                ...lessonInfo,
                type: "Unit",
              });
            }
            if (isOnlyNotCompletedLesson) {
              trackEvent(Events.actions.allLessonsCompletedInUnit, lessonInfo);
            } else if (currentUnit && !currentUnit?.progress) {
              trackEvent(Events.actions.startUnit, lessonInfo);
            }
          }
        }
      },
    });

  const [updateHeaLessonComplete, { loading: heaLessonCompleteInProgress }] =
    useHeaUpdateLessonStatusMutation({
      onError(e) {
        logger.debug(`[e]`, e);
      },
      update(_, __, { variables }) {
        if (isHomeEDApp) {
          if (variables?.input.status === LessonStatus.Completed) {
            trackEvent(Events.actions.lessonCompleted, {
              ...lessonInfo,
              study_plan_id: studyPlan?.id,
              study_plan_name: studyPlan?.name,
              type: "Unit",
            });
            if (isOnlyNotCompletedLesson) {
              trackEvent(Events.actions.allLessonsCompletedInUnit, {
                ...lessonInfo,
                study_plan_id: studyPlan?.id,
                study_plan_name: studyPlan?.name,
                type: "Unit",
              });
            }
          }
        }
      },
    });
  const [cancelFeedbackForm, { loading: canceling }] =
    useCancelFeedbackFormMutation({
      onError(e) {
        logger.debug(`[e]`, e);
      },
      onCompleted(data) {
        if (data.cancelFeedbackForm) {
          removeFormId(lesson.id);
          const tickets = exitTickets.map((ticket) => {
            if (lesson?.number === ticket.lessonNum) {
              return {
                ...ticket,
                status: false,
                exitTicketCount: 0,
                expiryMinutes: 0,
                copyLink: "",
                code: "",
              };
            }
            return ticket;
          });
          setExitTickets(tickets);
        }
      },
    });
  useEffect(() => {
    if (descriptionAnswers) {
      setBox(JSON.parse(descriptionAnswers || "[]"));
    }
  }, [descriptionAnswers]);

  useEffect(() => {
    if (confirmedPassword && completeLesson) {
      if (
        lesson?.id === completeLesson.id &&
        !loading &&
        !heaLessonCompleteInProgress &&
        !getHeaLessonStatusLoading
      ) {
        if (isHomeEDApp) {
          if (!studyPlan?.id) {
            return;
          }
          const fetchData = async () => {
            const res = await updateHeaLessonComplete({
              variables: {
                input: {
                  studyplanId: studyPlan?.id,
                  unitId,
                  lessonId: lesson.id,
                  status: complete
                    ? LessonStatus.NotStarted
                    : LessonStatus.Confirmed,
                },
              },
            });
            setConfirmedPassword(false);
            return res.data?.heaUpdateLessonStatus;
          };

          fetchData()
            .then((res) => {
              if (res) {
                getHeaLessonCompletedStatus?.();
                successToast("Lesson Status has been Updated Successfully!");
              }
            })
            .catch(console.error);
        }
      }
    }
  }, [
    completeLesson,
    confirmedPassword,
    lesson.id,
    loading,
    heaLessonCompleteInProgress,
    getHeaLessonStatusLoading,
    studyPlan?.id,
    updateHeaLessonComplete,
    unitId,
    complete,
    getHeaLessonCompletedStatus,
    successToast,
    setConfirmedPassword,
  ]);

  const preLessonNum = useMemo(() => preLesson?.number, [preLesson?.number]);
  const prerequisiteNumbers = useMemo(() => {
    if (!preRequiredLessonNumbers?.length) {
      return "";
    }
    if (preRequiredLessonNumbers?.length === 1) {
      return `${preRequiredLessonNumbers[0]}`;
    }
    return `${preRequiredLessonNumbers.splice(0, preRequiredLessonNumbers.length - 1).join(", ")} and ${preRequiredLessonNumbers[preRequiredLessonNumbers.length - 1]}`;
  }, [preRequiredLessonNumbers]);

  const filteredStudyPlans = useMemo(
    () => [...(studyPlansForSelectedUnit || [])],
    [studyPlansForSelectedUnit],
  );

  const handleOpenPreview = () => {
    setShowMenu(false);
    setShowExitTicketMenu(false);
    // setShowExitTicketActiveMenu(false);
    openPreview(lesson);
  };
  const handleStartLesson = () => {
    setShowMenu(false);
    setShowExitTicketMenu(false);
    // setShowExitTicketActiveMenu(false);
    openDetails(lesson);
  };
  const handleResumeClick = () => {
    setLesson(lesson);
    setShowMenu(false);
    setShowExitTicketMenu(false);
    handleResumeMenu?.(lesson);
  };

  const handleStartBeginClick = () => {
    setLesson(lesson);
    setShowMenu(false);
    setShowExitTicketMenu(false);
    handleStartBeginMenu?.(lesson);
  };

  const handleStartLessonWithChilds = () => {
    setShowMenu(false);
    setShowExitTicketMenu(false);
    // setShowExitTicketActiveMenu(false);
    setShowCompleteOptionMenu(false);
    if (openLessonWithChilds) {
      openLessonWithChilds(lesson);
    }
  };
  const handleOpenFeedback = (e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation();
    } else {
      e.stopPropagation();
    }
    setShowMenu(false);
    setShowExitTicketMenu(false);
    // setShowExitTicketActiveMenu(false);
    openTeacherFeedback(lesson);
    setFeedbackStatusWithLesson(lesson.id, "Hidden");
  };

  const handleOpenExitTicket = (e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation();
    } else {
      e.stopPropagation();
    }
    setShowMenu(false);
    setShowCompleteOptionMenu(false);
    if (studyPlan) {
      openExitTicket?.(lesson, studyPlan);
    }
  };

  const handleReviewNow = (e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation();
    } else {
      e.stopPropagation();
    }
    setShowMenu(false);
    setShowCompleteOptionMenu(false);
    reviewNow?.(lesson);
  };

  const items: MenuProps["items"] =
    studyMode !== ModeTypeEnum.Units
      ? isLocked
        ? [
            {
              key: "2",
              label: filteredStudyPlans.length > 0 && (
                <div
                  className={styles.dropDownMenuitem}
                  onClick={
                    isLocked
                      ? handleStartLesson
                      : filteredStudyPlans.length === 0
                        ? handleStartLesson
                        : handleStartLessonWithChilds
                  }
                >
                  <div>Start Lesson</div>
                </div>
              ),
            },
          ]
        : inprogress && progress && progress > 0
          ? [
              {
                key: "1",
                label: (
                  <div
                    className={styles.dropDownMenuitem}
                    onClick={handleOpenPreview}
                  >
                    Preview Lesson
                  </div>
                ),
              },
              {
                key: "2",
                label: (
                  <div
                    className={styles.dropDownResumnMenuitem}
                    onClick={handleResumeClick}
                  >
                    <div className={styles.resumeMenuItem}>
                      <div className={styles.resumeProgressBackBar}>
                        <div
                          className={styles.resumeProgressBar}
                          style={{
                            width: `${complete ? (completeRequire ? 0 : 100) : completeRequire ? 100 : inprogress ? progress : 0}%`,
                            backgroundColor: complete ? "#62C590" : "#62C590",
                            borderBottomRightRadius: complete ? "3px" : "0",
                          }}
                        ></div>
                        <span className={styles.inprogressText}>
                          Lesson in Progress
                        </span>
                      </div>
                      <div className={styles.resumeText}>Resume Lesson</div>
                    </div>
                  </div>
                ),
              },
              {
                key: "3",
                label:
                  !isHomeEDApp || isParentUnit ? (
                    <div
                      className={styles.dropDownMenuitem}
                      onClick={handleStartBeginClick}
                    >
                      Start from Beginning
                    </div>
                  ) : (
                    filteredStudyPlans.length > 0 && (
                      <div
                        className={styles.dropDownMenuitem}
                        onClick={
                          isLocked
                            ? handleStartLesson
                            : filteredStudyPlans.length === 0
                              ? handleStartLesson
                              : handleStartLessonWithChilds
                        }
                      >
                        <div>Start Study Plan</div>
                      </div>
                    )
                  ),
              },
            ]
          : [
              {
                key: "1",
                label: (
                  <div
                    className={styles.dropDownMenuitem}
                    onClick={handleOpenPreview}
                  >
                    Preview Lesson
                  </div>
                ),
              },
              {
                key: "2",
                label:
                  !isHomeEDApp || isParentUnit ? (
                    <div
                      className={styles.dropDownMenuitem}
                      onClick={handleStartLesson}
                    >
                      Start Lesson
                    </div>
                  ) : (
                    filteredStudyPlans.length > 0 && (
                      <div
                        className={styles.dropDownMenuitem}
                        onClick={
                          isLocked
                            ? handleStartLesson
                            : filteredStudyPlans.length === 0
                              ? handleStartLesson
                              : handleStartLessonWithChilds
                        }
                      >
                        <div>Start Study Plan</div>
                      </div>
                    )
                  ),
              },
            ]
      : [
          {
            key: "1",
            label: !isLocked && (
              <div
                className={styles.dropDownMenuitem}
                onClick={handleOpenPreview}
              >
                Preview Lesson
              </div>
            ),
          },
        ];

  const generateExitTicket = (e: any) => {
    setShowExitTicketMenu(false);
    // setShowExitTicketActiveMenu(false);
    if (e.domEvent) {
      e.domEvent.stopPropagation();
    } else {
      e.stopPropagation();
    }
    if (handleGenerateTicket) {
      handleGenerateTicket(lesson);
    }
  };

  const cancelExitTicket = (e: any) => {
    setShowExitTicketMenu(false);
    // setShowExitTicketActiveMenu(false);
    if (e.domEvent) {
      e.domEvent.stopPropagation();
    } else {
      e.stopPropagation();
    }
    if (handleCancelExitTicket) {
      const formId = getFormId(lesson.id);
      if (formId) {
        cancelFeedbackForm({
          variables: {
            input: { id: formId },
          },
        });
      }
    }
  };

  const copyToClipboard = (e: any) => {
    setShowExitTicketMenu(false);
    // setShowExitTicketActiveMenu(false);
    if (e.domEvent) {
      e.domEvent.stopPropagation();
    } else {
      e.stopPropagation();
    }
    successToast("Link Copied Successfully!");
  };

  useEffect(() => {
    if (exitTicket?.expiryMinutes === 0 && exitTicket?.status) {
      if (handleCancelExitTicket) {
        const formId = getFormId(lesson.id);
        if (formId) {
          cancelFeedbackForm({
            variables: {
              input: { id: formId },
            },
          });
        }
      }
    }
  }, [
    exitTicket,
    lesson,
    handleCancelExitTicket,
    cancelFeedbackForm,
    getFormId,
  ]);

  const ticketActiveMenu: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <div
          className={styles.activeInfoMenu}
          onClick={(e) => e.stopPropagation()}
        >
          <OutlineIcon width={21} className={styles.warningIcon} />
          <div className={styles.activeInfo}>
            <span>
              <strong>
                {Math.round((exitTicket?.expiryMinutes ?? 0) / 60)}
              </strong>{" "}
              Minutes Left
            </span>
            <span>
              <strong>{exitTicket?.exitTicketCount}</strong> Responses Max
            </span>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: <div className={styles.dropDownMenuitem}>Cancel</div>,
      onClick: (e) => cancelExitTicket(e),
    },
    {
      key: "3",
      label: (
        <CopyToClipboardComponent text={exitTicket?.copyLink ?? ""}>
          <div className={styles.dropDownMenuitem}>Copy Link</div>
        </CopyToClipboardComponent>
      ),
      onClick: (e) => copyToClipboard(e),
    },
    {
      key: "4",
      label: <div className={styles.dropDownMenuitem}>Regenerate</div>,
      onClick: (e) => generateExitTicket(e),
    },
  ];

  const handleClickActiveMenu = (e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation();
    } else {
      e.stopPropagation();
    }
  };

  const activeSurveyTitle = (type: Number) => {
    switch (type) {
      case SURVEY_TYPE.RESEARCH: {
        return "Research Survey Active";
      }
      case SURVEY_TYPE.NA_PRE_PROGRAM_QUIZ: {
        return "Pre-Program Active";
      }
      case SURVEY_TYPE.EXIT_TICKET: {
        return "Exit Ticket Active";
      }
      case SURVEY_TYPE.NA_POST_PROGRAM_QUIZ: {
        return "Post-Program Active";
      }
      default: {
        return "Research Survey Active";
      }
    }
  };

  const generateSurveyTitle = (type: Number) => {
    switch (type) {
      case SURVEY_TYPE.RESEARCH: {
        return "Generate Survey Link";
      }
      case SURVEY_TYPE.NA_PRE_PROGRAM_QUIZ: {
        return "Generate Pre-Program Quiz";
      }
      case SURVEY_TYPE.EXIT_TICKET: {
        return "Generate Exit Ticket";
      }
      case SURVEY_TYPE.NA_POST_PROGRAM_QUIZ: {
        return "Generate Post-Program Quiz";
      }
      default: {
        return "Generate Survey Link";
      }
    }
  };

  const normalMenu: MenuProps["items"] = [
    {
      key: "3",
      label: <div className={styles.dropDownMenuitem}>{"Rate Lesson"}</div>,
      onClick: (e) => handleOpenFeedback(e),
    },
  ];
  const ticketActivatedMenu: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <Dropdown
          menu={{ items: ticketActiveMenu }}
          trigger={["hover"]}
          placement="top"
        >
          <div className={styles.exitTicketActiveButton}>
            {exitTicket?.type ? activeSurveyTitle(exitTicket?.type) : ""}
          </div>
        </Dropdown>
      ),
      onClick: (e) => handleClickActiveMenu(e),
    },
    // {
    //   key: '2',
    //   label: (
    //     <div className={styles.dropDownMenuitem} onClick={handleOpenPreview}>
    //       Generate Home Link
    //     </div>
    //   ),
    // },
    {
      key: "3",
      label: <div className={styles.dropDownMenuitem}>{"Rate Lesson"}</div>,
      onClick: (e) => handleOpenFeedback(e),
    },
  ];
  const ticketGenerateMenu: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <div className={styles.dropDownMenuitem}>
          {exitTicket?.type ? generateSurveyTitle(exitTicket?.type) : ""}
        </div>
      ),
      onClick: (e) => generateExitTicket(e),
    },
    // {
    //   key: '2',
    //   label: (
    //     <div className={styles.dropDownMenuitem} onClick={handleOpenPreview}>
    //       Generate Home Link
    //     </div>
    //   ),
    // },
    {
      key: "3",
      label: <div className={styles.dropDownMenuitem}>{"Rate Lesson"}</div>,
      onClick: (e) => handleOpenFeedback(e),
    },
  ];

  const completeOptionMenuitemStyle = useMemo(() => {
    const classes = [styles.completeOptionMenuitem];

    if (incompleted) {
      classes.push(styles.completeMenuItem);
    }
    return classes.join(" ");
  }, [incompleted]);

  const handleLessonInComplete = (e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation();
    } else {
      e.stopPropagation();
    }
    setShowMenu(false);
    setShowCompleteOptionMenu(false);
    if (lesson && studyPlan) {
      reviewLesson?.(lesson, studyPlan);
    }
  };

  const handleLessonComplete = (e: any) => {
    if (e.domEvent) {
      e.domEvent.stopPropagation();
    } else {
      e.stopPropagation();
    }
    setShowMenu(false);
    setShowCompleteOptionMenu(false);
    if (lesson && studyPlan) {
      confirmNow?.(lesson, studyPlan);
    }
  };

  const completeMenu: MenuProps["items"] = [
    {
      key: "sub1",
      label: (
        <div className={styles.incompleteOptionMenuitem}>
          <CloseIcon /> {"Incomplete"}
        </div>
      ),
      onClick: (e) => handleLessonInComplete(e),
    },
    {
      key: "sub2",
      label: (
        <div className={completeOptionMenuitemStyle}>
          <CheckIcon /> {"Complete"}
        </div>
      ),
      onClick: (e) => handleLessonComplete(e),
    },
  ];

  const reviewMenu: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <div className={styles.reviewOptionMenuitem}>{"View Exit Ticket"}</div>
      ),
      onClick: (e) => handleOpenExitTicket(e),
    },
    {
      key: "2",
      label: <div className={styles.reviewOptionMenuitem}>{"Complete?"}</div>,
      children: completeMenu,
      onClick: (e) => handleClickActiveMenu(e),
      onTitleClick: (e) => handleClickActiveMenu(e),
    },
    {
      key: "3",
      label: <div className={styles.reviewOptionMenuitem}>{"Review Now"}</div>,
      onClick: (e) => handleReviewNow(e),
    },
  ];

  const isConfirmCompletion = useMemo(() => {
    return (
      isHomeEDApp &&
      studyMode === ModeTypeEnum.Study &&
      (lesson.status === LessonStatus.Completed ||
        lesson.status === LessonStatus.Confirmed)
    );
  }, [studyMode, lesson.status]);

  const lessonNumStyle = useMemo(() => {
    const classes = [styles.lessonNum];
    if (isConfirmCompletion) {
      if (isHovered) {
        if (isRequire) {
          classes.push(styles.suggestBorder);
        } else {
          classes.push(styles.hoverneedcompleteSubView);
        }
      } else if (lesson.status === LessonStatus.Completed) {
        if (incompleted) {
          classes.push(styles.needReviewNum);
        } else {
          classes.push(styles.needcompleteNum);
        }
      }
    }
    if (completeRequire) {
      if (complete) {
        classes.push(styles.incompleteBorder);
      } else {
        classes.push(styles.completeNumBorder);
      }
    }
    if (isHovered) {
      if (isRequire) {
        classes.push(styles.suggestNumBorder);
      } else {
        classes.push(styles.hoverBorder);
      }
    }
    return classes.join(" ");
  }, [
    incompleted,
    completeRequire,
    complete,
    isHovered,
    isRequire,
    isConfirmCompletion,
    lesson.status,
  ]);

  const topBorderStyle = useMemo(() => {
    const classes = [styles.cardTopBorderView];
    if (isConfirmCompletion) {
      if (isHovered) {
        if (isRequire) {
          classes.push(styles.suggestBorder);
        } else {
          classes.push(styles.hoverBorder);
        }
      } else if (lesson.status === LessonStatus.Completed) {
        if (incompleted) {
          classes.push(styles.needReviewBorder);
        } else {
          classes.push(styles.needcompleteBorder);
        }
      }
    }
    if (completeRequire) {
      if (complete) {
        classes.push(styles.incompleteBorder);
      } else {
        classes.push(styles.completeTopBorder);
      }
    }
    if (isHovered) {
      if (isRequire) {
        classes.push(styles.suggestBorder);
      } else {
        classes.push(styles.hoverBorder);
      }
    }

    return classes.join(" ");
  }, [
    incompleted,
    completeRequire,
    complete,
    isHovered,
    isRequire,
    isConfirmCompletion,
    lesson.status,
  ]);

  const bottomBorderStyle = useMemo(() => {
    const classes = [styles.cardBottomBorderView];
    if (isConfirmCompletion) {
      if (isHovered) {
        if (isRequire) {
          classes.push(styles.suggestBorder);
        } else {
          classes.push(styles.hoverBorder);
        }
      } else if (lesson.status === LessonStatus.Completed) {
        if (incompleted) {
          classes.push(styles.needReviewBorder);
        } else {
          classes.push(styles.needcompleteBorder);
        }
      }
    }
    if (completeRequire) {
      if (complete) {
        classes.push(styles.incompleteBorder);
      } else {
        classes.push(styles.completeBottomBorder);
      }
    }
    if (isHovered) {
      if (isRequire) {
        classes.push(styles.suggestBorder);
      } else {
        classes.push(styles.hoverBorder);
      }
    }

    return classes.join(" ");
  }, [
    incompleted,
    completeRequire,
    complete,
    isHovered,
    isRequire,
    isConfirmCompletion,
    lesson.status,
  ]);

  const preRequestStyle = useMemo(() => {
    const classes = [styles.preRequestSubView];
    if (isConfirmCompletion) {
      if (isHovered) {
        classes.push(styles.hoverBorder);
      } else {
        if (incompleted) {
          classes.push(styles.needReviewBorder);
        } else {
          if (lesson.status === LessonStatus.Completed) {
            classes.push(styles.needcompleteSubView);
          } else {
            classes.push(styles.completeTopBorder);
          }
        }
      }
    }
    if (completeRequire) {
      if (complete) {
        classes.push(styles.incompleteBorder);
      } else {
        classes.push(styles.completeTopBorder);
      }
    }
    return classes.join(" ");
  }, [
    incompleted,
    completeRequire,
    isHovered,
    complete,
    isConfirmCompletion,
    lesson.status,
  ]);

  const imageStyle = useMemo(() => {
    const classes = [styles.image];
    if (completeRequire) {
      classes.push(styles.hidden);
    }
    return classes.join(" ");
  }, [completeRequire]);

  const completedCheckStyle = useMemo(() => {
    const classes = [styles.completedCheck];
    if (isConfirmCompletion) {
      if (isHovered) {
        if (isRequire) {
          classes.push(styles.suggestBorder);
        } else {
          classes.push(styles.hoverBorder);
        }
      } else if (lesson.status === LessonStatus.Completed) {
        if (incompleted) {
          classes.push(styles.needReviewBorder);
        } else {
          classes.push(styles.needcompleteTopBorder);
        }
      }
    }
    if (completeRequire) {
      if (complete) {
        classes.push(styles.normalBorder);
      } else {
        classes.push(styles.completeTopBorder);
      }
    }
    if (isHovered) {
      if (isRequire) {
        classes.push(styles.suggestBorder);
      } else {
        classes.push(styles.hoverBorder);
      }
    }
    return classes.join(" ");
  }, [
    incompleted,
    completeRequire,
    complete,
    isHovered,
    isRequire,
    isConfirmCompletion,
    lesson.status,
  ]);

  const completeCheckIconStyle = useMemo(() => {
    const classes = [styles.completeCheckIcon];
    if (isHovered) {
      classes.push(styles.hoverneednormalCheckIcon);
    }
    return classes.join(" ");
  }, [isHovered]);

  const normalCheckIconStyle = useMemo(() => {
    const classes = [styles.normalCheckIcon];
    if (isHomeEDApp && isLocked && lesson.status === LessonStatus.Completed) {
      if (isHovered) {
        classes.push(styles.hoverneednormalCheckIcon);
      } else {
        classes.push(styles.neednormalCheckIcon);
      }
    }
    return classes.join(" ");
  }, [isHovered, isLocked, lesson.status]);
  const burgerButtonStyle = useMemo(() => {
    const classes = [styles.burgerButton];
    if (complete) {
      classes.push(styles.completeBurgerButton);
    }

    if (isHovered) {
      if (isRequire) {
        classes.push(styles.suggestBurgerButton);
      }
    }

    if (feedbackLoading || canceling) {
      classes.push(styles.loadingBurgerButton);
    }
    return classes.join(" ");
  }, [complete, isHovered, isRequire, feedbackLoading, canceling]);

  const shareButtonStyle = useMemo(() => {
    const classes = [styles.shareButton];
    if (complete) {
      classes.push(styles.completeBurgerButton);
    }

    if (isHovered) {
      if (isRequire) {
        classes.push(styles.suggestBurgerButton);
      }
    }

    if (feedbackLoading || canceling) {
      classes.push(styles.loadingBurgerButton);
    }
    return classes.join(" ");
  }, [complete, isHovered, isRequire, feedbackLoading, canceling]);

  const completedPathStyle = useMemo(() => {
    const classes = [styles.inCompleteConnectView];
    if (isRequire) {
      classes.push(styles.completeSuggestConnectPath);
    } else {
      classes.push(styles.completeConnectPath);
    }

    return classes.join(" ");
  }, [isRequire]);

  const materialViewStyle = useMemo(() => {
    const classes = [styles.materialSubView];

    if (completeRequire) {
      if (complete) {
        classes.push(styles.incompleteBorder);
      } else {
        classes.push(styles.completeTopBorder);
      }
    }
    if (isHovered) {
      if (isRequire) {
        classes.push(styles.suggestBorder);
      } else {
        classes.push(styles.hoverBorder);
      }
    }
    if (!selectMaterial) {
      classes.push(styles.noborder);
    }
    return classes.join(" ");
  }, [completeRequire, complete, isHovered, isRequire, selectMaterial]);

  const feedbackButtonStyle = useMemo(() => {
    const enabledFeedback = getFeedbackStatusWithLesson(lesson.id);
    const classes = [styles.feedbackButton];

    if (enabledFeedback === "Enable") {
      classes.push(styles.pulseAnimation);
    } else if (enabledFeedback === "Hidden") {
      classes.push(styles.feedBackHidden);
    }
    return classes.join(" ");
  }, [getFeedbackStatusWithLesson, lesson.id]);

  const burgeritems: MenuProps["items"] = [
    {
      label: "",
      key: "SubMenu",
      icon: (
        <Button
          disabled={canceling || feedbackLoading}
          label=""
          size="small"
          className={burgerButtonStyle}
          onClick={(e) => e.stopPropagation()}
          leftIcon={
            canceling || feedbackLoading ? (
              <Spinner width={20} height={20} />
            ) : (
              <BurgerIcon />
            )
          }
        />
      ),
      children: exitTicket?.formData
        ? exitTicket?.status
          ? ticketActivatedMenu
          : ticketGenerateMenu
        : normalMenu,
    },
  ];

  const handleHover = useCallback((status: boolean) => {
    setIsHovered(status);
  }, []);

  const handleSelectMaterials = useCallback(
    (e: any) => {
      if (e.domEvent) {
        e.domEvent.stopPropagation();
      } else {
        e.stopPropagation();
      }
      if (selectedLessonId === lesson.id) {
        setSelectMaterial(false);
        setSelectedLessonId(undefined);
        setLesson(undefined);
      } else {
        setSelectMaterial(true);
        setSelectedLessonId(lesson.id);
      }
    },
    [lesson, selectedLessonId, setLesson],
  );

  const handleDownloadLessonMaterial = useCallback(
    (content: Content) => {
      handleDownloadMaterial?.(content, lesson);
    },
    [lesson, handleDownloadMaterial],
  );

  const handlePrintMaterial = useCallback(
    (content: Content) => {
      handleDownloadMaterial?.(content, lesson, true);
    },
    [lesson, handleDownloadMaterial],
  );

  const requiredMaterials = useMemo(() => {
    if (!lesson?.materials) return [];
    return lesson?.materials.filter(
      (material) => material?.isRequired === true,
    );
  }, [lesson?.materials]);

  const optionalMaterials = useMemo(() => {
    if (!lesson?.materials) return [];
    return lesson?.materials.filter(
      (material) => material?.isRequired === false,
    );
  }, [lesson?.materials]);

  const lessonMaterials = useMemo(() => {
    return (
      <div className={materialViewStyle}>
        <CollapseComponent isOpened={selectMaterial && selectedLessonId === lesson.id}>
          <div className={styles.materialContents}>
            <div className={styles.subView}>
              {hasArrayValues(requiredMaterials) && (
                <div className={styles.materialSubContents}>
                  <div className={styles.requireTitle}>
                    Required
                    <LordIcon
                      src={IconInfo}
                      isHover={true}
                      colors={{ primary: "#FFB073", secondary: "#FFB073" }}
                      size={20}
                    />
                  </div>
                  <div className={styles.unitsDiv}>
                    {requiredMaterials.map((material, index) => {
                      return (
                        <MaterialCard
                          key={index}
                          content={material}
                          handleDownloadMaterial={handleDownloadLessonMaterial}
                          handlePrintMaterial={handlePrintMaterial}
                        />
                      );
                    })}
                  </div>
                </div>
              )}
              {hasArrayValues(optionalMaterials) && (
                <div className={styles.materialSubContents}>
                  <div className={styles.optionTitle}>
                    Optional
                    <LordIcon
                      src={IconInfo}
                      isHover={true}
                      colors={{ primary: "#6C969A", secondary: "#6C969A" }}
                      size={20}
                    />
                  </div>
                  <div className={styles.unitsDiv}>
                    {optionalMaterials.map((material, index) => {
                      return (
                        <MaterialCard
                          key={index}
                          content={material}
                          handleDownloadMaterial={handleDownloadLessonMaterial}
                          handlePrintMaterial={handlePrintMaterial}
                        />
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </CollapseComponent>
      </div>
    );
  }, [
    lesson,
    selectedLessonId,
    selectMaterial,
    materialViewStyle,
    requiredMaterials,
    optionalMaterials,
    handleDownloadLessonMaterial,
    handlePrintMaterial,
  ]);

  const inCompleteLessons =
    isHomeEDApp && isLocked
      ? getInCompleteLessons([...(currentHeaUnit?.classPresentation || [])])
      : "";

  const statusContent = useMemo(() => {
    if (
      preLesson?.status === LessonStatus.Completed ||
      (preLesson?.status === LessonStatus.Confirmed && isHomeEDApp)
    ) {
      return (
        <>
          <div
            className={styles.completeConnectView}
            onClick={(e) => e.stopPropagation()}
          >
            <ConnectIcon height={39} />
          </div>
          <div
            className={styles.preRequestView}
            onClick={(e) => e.stopPropagation()}
            onMouseOver={() => handleHover(true)}
            onMouseLeave={() => handleHover(false)}
          >
            <div
              className={
                isHovered ? styles.preRequestHoverSubView : preRequestStyle
              }
            >
              Pre-requisite:&nbsp;
              <div className={styles.preRequestSubtitle}>
                Lesson {preLessonNum}
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div
            className={styles.normalConnectView}
            onClick={(e) => e.stopPropagation()}
          >
            {isHovered && isRequire ? (
              <DisconnectIcon height={42} />
            ) : (
              <MisconnectIcon height={42} />
            )}
          </div>
          <div
            className={styles.preRequestView}
            onClick={(e) => e.stopPropagation()}
            onMouseOver={() => handleHover(true)}
            onMouseLeave={() => handleHover(false)}
          >
            {isLocked && isHovered ? (
              index === lessonCount - 1 ? (
                <div className={styles.preLessonRequiredTextView}>
                  Your&nbsp;<strong>Parent or Carer</strong>&nbsp;needs to
                  confirm you completed&nbsp;
                  <strong>
                    Lesson{" "}
                    {inCompleteLessons ? inCompleteLessons : preLessonNum}
                  </strong>
                  &nbsp;before continuing.
                </div>
              ) : (
                <div className={styles.preLessonRequiredTextView}>
                  <strong>Lesson {preLessonNum}</strong>&nbsp;needs to be
                  approved before you can move onto&nbsp;
                  <strong>Lesson {number}</strong>
                </div>
              )
            ) : (
              <div
                className={
                  isHovered
                    ? isRequire
                      ? styles.preRequestActiveSubView
                      : styles.preRequestHoverSubView
                    : preRequestStyle
                }
              >
                Pre-requisite:&nbsp;
                <div
                  className={
                    isHovered && isRequire
                      ? styles.preRequestActiveSubtitle
                      : styles.preRequestSubtitle
                  }
                >
                  Lesson {preLessonNum}
                </div>
              </div>
            )}
          </div>
          {!isLocked && isHovered && isRequire ? (
            <div
              className={styles.suggestView}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className={styles.suggestSubView}
              >{`Please complete Lesson ${prerequisiteNumbers || ""} prior to beginning this lesson`}</div>
            </div>
          ) : null}
        </>
      );
    }
  }, [
    preLesson?.status,
    isHovered,
    preRequestStyle,
    preLessonNum,
    handleHover,
    isRequire,
    isLocked,
    index,
    lessonCount,
    inCompleteLessons,
    number,
    prerequisiteNumbers,
  ]);

  const heStatusContent = useMemo(() => {
    if (
      preLesson?.status === LessonStatus.Confirmed ||
      lesson.status === LessonStatus.Confirmed
    ) {
      return (
        <>
          <div
            className={styles.completeConnectView}
            onClick={(e) => e.stopPropagation()}
          >
            <ConnectIcon height={39} />
          </div>
          <div
            className={styles.preRequestView}
            onClick={(e) => e.stopPropagation()}
            onMouseOver={() => handleHover(true)}
            onMouseLeave={() => handleHover(false)}
          >
            <div
              className={
                isHovered ? styles.preRequestHoverSubView : preRequestStyle
              }
            >
              Pre-requisite:&nbsp;
              <div className={styles.preRequestSubtitle}>
                Lesson {preLessonNum}
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div
            className={styles.normalConnectView}
            onClick={(e) => e.stopPropagation()}
          >
            {isHovered && isRequire ? (
              <DisconnectIcon height={42} />
            ) : (
              <MisconnectIcon height={42} />
            )}
          </div>
          <div
            className={styles.preRequestView}
            onClick={(e) => e.stopPropagation()}
            onMouseOver={() => handleHover(true)}
            onMouseLeave={() => handleHover(false)}
          >
            {isHovered ? (
              <div className={styles.preLessonRequiredTextView}>
                {isLocked ? (
                  <>
                    <strong>Lesson {preLessonNum}</strong>&nbsp;needs to be
                    approved before continuing.
                  </>
                ) : preLesson?.status === LessonStatus.Completed ? (
                  <>
                    You must approve&nbsp;<strong>Lesson {preLessonNum}</strong>
                    &nbsp;before this lesson can be started.
                  </>
                ) : (
                  <>
                    <strong>Lesson {prerequisiteNumbers}</strong>&nbsp;must be
                    completed before this lesson can be started.
                  </>
                )}
              </div>
            ) : (
              <div className={preRequestStyle}>
                Pre-requisite:&nbsp;
                <div
                  className={
                    isHovered && isRequire
                      ? styles.preRequestActiveSubtitle
                      : styles.preRequestSubtitle
                  }
                >
                  Lesson {preLessonNum}
                </div>
              </div>
            )}
          </div>
        </>
      );
    }
  }, [
    preLesson?.status,
    lesson.status,
    isHovered,
    preRequestStyle,
    preLessonNum,
    handleHover,
    isRequire,
    isLocked,
    prerequisiteNumbers,
  ]);

  const statusHoverContent = useMemo(() => {
    if (completeRequire && !nextLesson?.prerequisite) {
      if (status === "completed") {
        return (
          <>
            <div
              className={styles.inCompleteConnectView}
              onClick={(e) => e.stopPropagation()}
            >
              <InCompleteConnectIcon width={20} height={39} />
            </div>
          </>
        );
      } else {
        return (
          <>
            <div
              className={styles.inCompleteConnectView}
              onClick={(e) => e.stopPropagation()}
            >
              <CompleteConnectIcon width={20} height={39} />
            </div>
          </>
        );
      }
    } else {
      if (status === "completed" && isHovered && !nextLesson?.prerequisite) {
        return (
          <>
            <div
              className={completedPathStyle}
              onClick={(e) => e.stopPropagation()}
            >
              <ConnectIcon width={20} height={39} />
            </div>
          </>
        );
      }
    }
  }, [completeRequire, status, isHovered, completedPathStyle, nextLesson]);

  const markLessonAsComplete = useCallback(
    async (e: any) => {
      if (e.domEvent) {
        e.domEvent.stopPropagation();
      } else {
        e.stopPropagation();
      }
      if (
        lesson?.id &&
        !loading &&
        !heaLessonCompleteInProgress &&
        !getHeaLessonStatusLoading
      ) {
        if (isHomeEDApp) {
          if (!studyPlan?.id) {
            return;
          }
          const res = await updateHeaLessonComplete({
            variables: {
              input: {
                studyplanId: studyPlan?.id,
                unitId,
                lessonId: lesson.id,
                status: complete
                  ? LessonStatus.NotStarted
                  : LessonStatus.Confirmed,
              },
            },
          });
          if (res?.data?.heaUpdateLessonStatus) {
            getHeaLessonCompletedStatus?.();
            successToast("Lesson Status has been Updated Successfully!");
          }
          if (complete) {
            const updatedTrackData = {
              unit_name: currentUnit?.name || "",
              unit_id: currentUnit?.id || "",
              course_name: program?.name || "",
              course_id: program?.id || "",
              lesson_name: lesson.name || "",
              lesson_id: lesson.id || "",
              lesson_position: lesson.number || 0,
              study_plan_id: currentStudyplan?.id,
              study_plan_name: currentStudyplan?.name,
              grade: program?.name || "",
            };
            trackEvent(Events.actions.lessonCompleted, {
              ...updatedTrackData,
              type: "Unit",
            });
          }
        } else {
          const res = await updateLessonComplete({
            variables: {
              input: {
                unitId,
                lessonId: lesson.id,
                status: complete
                  ? LessonStatus.NotStarted
                  : LessonStatus.Completed,
              },
            },
          });
          if (res?.data?.updateLessonCompleteStatus) {
            successToast("Lesson Status has been Updated Successfully!");
            if (complete) {
              removeFeedbackStatusWithLesson(lesson.id);

              const courseName =
                currentUnit?.name === "Educator Onboarding"
                  ? "Educator Onboarding"
                  : currentUnit?.name === "Educator Wellbeing"
                    ? "Educator Wellbeing"
                    : program?.name;
              const updatedTrackData = {
                unit_name: currentUnit?.name || "",
                unit_id: currentUnit?.id || "",
                course_name: courseName || "",
                course_id: program?.id || "",
                lesson_name: lesson.name || "",
                lesson_id: lesson.id || "",
                lesson_position: lesson.number || 0,
                grade: program?.name || "",
                schoolId: lessonInfo.schoolId,
                schoolName: lessonInfo.schoolName,
                userId: lessonInfo.userId,
                userName: lessonInfo.userName,
              };
              trackEvent(Events.actions.lessonCompleted, {
                ...updatedTrackData,
                type: "Unit",
              });
            } else {
              setFeedbackStatusWithLesson(lesson.id, "Enable");
            }
          }
        }
      }
    },
    [
      lessonInfo,
      lesson,
      loading,
      heaLessonCompleteInProgress,
      getHeaLessonStatusLoading,
      studyPlan?.id,
      unitId,
      complete,
      getHeaLessonCompletedStatus,
      successToast,
      updateLessonComplete,
      updateHeaLessonComplete,
      setFeedbackStatusWithLesson,
      removeFeedbackStatusWithLesson,
      trackEvent,
      currentUnit,
      program,
      currentStudyplan,
    ],
  );

  const handleConfirmComplete = useCallback(
    (e: any) => {
      if (e.domEvent) {
        e.domEvent.stopPropagation();
      } else {
        e.stopPropagation();
      }
      // openConfirmPassword(lesson)
      markLessonAsComplete(e);
    },
    [markLessonAsComplete],
  );

  const handleVisible = useCallback((visible: boolean) => {
    setShowMenu(visible);
    setShowExitTicketMenu(false);
    // setShowExitTicketActiveMenu(false);
    setShowCompleteOptionMenu(false);
  }, []);

  const handleExitTicketVisible = useCallback((visible: boolean) => {
    setShowMenu(false);
    setShowExitTicketMenu(visible);
  }, []);

  // const handleExitTicketActiveVisible = useCallback((visible: boolean) => {
  //   setShowMenu(false)
  //   setShowExitTicketActiveMenu(visible)
  // }, []);

  const handleConfirmCompletionVisible = useCallback((visible: boolean) => {
    setShowMenu(false);
    setShowCompleteOptionMenu(visible);
  }, []);

  const handleApprovalPending = (e: any) => {
    e.stopPropagation();
    openAppravalPendingModal?.();
  };

  const handleShowShareModal = (e: any) => {
    e.stopPropagation();
    handleOpenShareModal(lesson);
  };

  const startLesson = useMemo(() => {
    if (studyMode !== ModeTypeEnum.Study || !isHomeEDApp) return true;

    if (index === 0) {
      return true;
    } else {
      if (prerequisite) {
        return true;
      } else if (
        preLesson?.status === LessonStatus.Confirmed &&
        !prerequisite
      ) {
        return true;
      } else if (
        (lesson?.status === LessonStatus.Confirmed ||
          lesson?.status === LessonStatus.Completed) &&
        !prerequisite
      ) {
        return true;
      } else {
        return false;
      }
    }
  }, [studyMode, index, preLesson, prerequisite, lesson?.status]);

  return (
    <div
      className={`${styles.lessonContainer} ${complete ? styles.completed : incompleted ? styles.inReview : ""}`}
      onClick={() => isParentApp && openPreview(lesson)}
    >
      <Dropdown
        menu={{ items }}
        trigger={isParentApp ? [] : startLesson ? ["contextMenu", "click"] : []}
        onOpenChange={handleVisible}
        open={showMenu}
      >
        <div
          className={
            isHovered
              ? isRequire
                ? styles.prerequisiteHoverCard
                : styles.hoverCard
              : styles.card
          }
          onMouseOver={() => handleHover(true)}
          onMouseLeave={() => handleHover(false)}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={topBorderStyle}></div>
          <div className={bottomBorderStyle}></div>
          <div className={styles.lessonNumView}>
            <div className={lessonNumStyle}>{number}</div>
          </div>
          <div
            className={imageStyle}
            style={{
              backgroundImage: `url(${image ? getMediaAbsolutePath(image) : ""})`,
              position: "relative",
            }}
          >
            {sensitive && (
              <div className={styles.sensitiveView}>
                <div className={styles.sensitiveButton}>
                  {"SENSITIVE CONTENT"}
                  <Tooltip
                    placement="topLeft"
                    title={
                      <div className={styles.sensitiveTooltipText}>
                        {sensitiveTooltip ??
                          "This Lesson contains sensitive content. We recommend previewing the lessons to ensure you are comfortable with material."}
                      </div>
                    }
                    arrowPointAtCenter
                    color="#FFFFFF"
                  >
                    <WarningIcon width={13} className={styles.rightTipIcon} />
                  </Tooltip>
                </div>
              </div>
            )}
            {complete ? (
              <MarkCheckIcon className={styles.normal} width={34} height={34} />
            ) : (
              <div>
                {studyMode === ModeTypeEnum.Study ? (
                  incompleted ? (
                    <div className={styles.previewBanner}>
                      <ReviewImg />
                    </div>
                  ) : index !== 0 &&
                    preLesson?.status !== LessonStatus.Confirmed ? (
                    <Button
                      label=""
                      size="small"
                      className={styles.previewLock}
                      leftIcon={
                        isHovered ? (
                          <PreviewLockRed width={41} height={56} />
                        ) : (
                          <PreviewLock width={41} height={56} />
                        )
                      }
                    />
                  ) : lesson.status === LessonStatus.Completed ? (
                    <NormalCheckIcon
                      className={styles.neednormalCheckIcon}
                      width={34}
                      height={34}
                    />
                  ) : null
                ) : (
                  <Button
                    label={isLocked ? "Start" : "View"}
                    className={styles.startButton}
                    onClick={() => isParentApp && openPreview(lesson)}
                  />
                )}
                {inprogress && !completeRequire ? (
                  <InprogressIcon
                    className={styles.inprogressBadge}
                    width={34}
                    height={34}
                  />
                ) : null}
              </div>
            )}
            {complete || (inprogress && progress && progress > 0) ? (
              <div className={styles.progressBackBar}>
                <div
                  className={styles.progressBar}
                  style={{
                    width: `${complete ? (completeRequire ? 0 : 100) : completeRequire ? 100 : inprogress ? progress : 0}%`,
                    backgroundColor: complete
                      ? "#62C590"
                      : completeRequire
                        ? "#62C590"
                        : "#62C590",
                    borderBottomRightRadius: complete ? "3px" : "0",
                  }}
                ></div>
              </div>
            ) : null}
          </div>
          <section className={styles.content}>
            <div className={styles.head}>
              <div className={styles.title}>{name}</div>
              <div className={styles.duration}>
                {duration ? `${duration}m` : ""}
              </div>
            </div>
            <div className={styles.description}>
              <div className={styles.subheading}>
                {descriptionHeading ?? "This lesson helps students:"}
              </div>
              <ul className={styles.boxView}>
                {(box ?? []).map((content, index) => {
                  const optionStr: string = content as string;
                  return (
                    <li key={index} className={styles.questionBox}>
                      {optionStr}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className={styles.exitTicketView}>
              {isHomeEDApp ? (
                <>
                  {studyMode === ModeTypeEnum.Study &&
                  lesson.status === LessonStatus.Completed ? (
                    <>
                      {isLocked ? (
                        <Button
                          label="Approval Pending"
                          className={styles.lockConfirmCompletion}
                          onClick={handleApprovalPending}
                        />
                      ) : (
                        <Dropdown
                          menu={{ items: reviewMenu }}
                          trigger={["click"]}
                          placement="bottomRight"
                          onOpenChange={handleConfirmCompletionVisible}
                          open={showCompleteOptionMenu}
                        >
                          <div
                            className={styles.lockConfirmCompletion}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className={styles.textView}>
                              {"Approval Pending"}
                            </div>
                            <div className={styles.iconView}>
                              {
                                <BurgerIcon
                                  width={15}
                                  height={15}
                                  className={styles.burgerIcon}
                                />
                              }
                            </div>
                          </div>
                        </Dropdown>
                      )}
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  {lesson.status === LessonStatus.Completed ? (
                    <div
                      onMouseOver={() => setRateHover(true)}
                      onMouseLeave={() => setRateHover(false)}
                    >
                      <Tooltip
                        placement="topRight"
                        title={
                          <div className={styles.shareTip}>
                            Please click the button to share your thoughts on
                            the Lessons.
                          </div>
                        }
                        arrowPointAtCenter
                        overlayStyle={{ maxWidth: "529px" }}
                        color="#FFFFFF"
                      >
                        <div
                          className={feedbackButtonStyle}
                          onClick={handleOpenFeedback}
                        >
                          <LordIcon
                            src={IconRateLesson}
                            isHover={true}
                            colors={{
                              primary: rateHover ? "#FFB073" : "#6BC690",
                              secondary: rateHover ? "#FFB073" : "#6BC690",
                            }}
                            size={24}
                            target=".LessonForm_feedbackButton__hWzzy"
                          />
                          <span>Rate Lesson</span>
                        </div>
                      </Tooltip>
                    </div>
                  ) : null}
                  {exitTicket?.formData && exitTicket?.status && (
                    <Dropdown
                      menu={{ items: ticketActiveMenu }}
                      trigger={["click"]}
                      placement="bottomRight"
                      onOpenChange={handleExitTicketVisible}
                      open={showExitTicketMenu}
                    >
                      <Button
                        disabled={canceling || feedbackLoading}
                        label=""
                        size="small"
                        className={styles.activeButton}
                        onClick={(e) => e.stopPropagation()}
                        leftIcon={
                          canceling || feedbackLoading ? (
                            <Spinner width={20} height={20} />
                          ) : (
                            <TicketIcon />
                          )
                        }
                      />
                    </Dropdown>
                  )}
                  {/* <Dropdown menu={{ items: exitTicket?.formData ? (exitTicket?.status ? ticketActivatedMenu : ticketGenerateMenu) : normalMenu }} trigger={['click']} placement="bottomRight" onOpenChange={handleExitTicketActiveVisible} open={showExitTicketActiveMenu}>
                <Button disabled={canceling || feedbackLoading} label='' size='small' className={burgerButtonStyle} onClick={e => e.stopPropagation()} leftIcon={canceling || feedbackLoading ? <Spinner width={20} height={20} /> : <BurgerIcon />} />
              </Dropdown> */}
                  {unitId !== StudentWellBeingSurveyId && (
                    <div>
                      <Tooltip
                        placement="topRight"
                        title={
                          <div className={styles.shareTip}>Share Lesson</div>
                        }
                        arrowPointAtCenter
                        color="#FFFFFF"
                      >
                        <div
                          className={shareButtonStyle}
                          onClick={handleShowShareModal}
                        >
                          <ShareIcon width={26} height={26} />
                        </div>
                      </Tooltip>
                    </div>
                  )}
                  <Menu items={burgeritems} mode="horizontal" />
                </>
              )}
            </div>
          </section>
          {lesson.materials && lesson.materials?.length > 0 && (
            <div className={styles.materialView}>
              <Button
                size="small"
                className={styles.materialButton}
                label="DOWNLOAD LESSON MATERIALS"
                leftIcon={
                  <Tooltip
                    placement="topLeft"
                    title={
                      <div className={styles.sensitiveTooltipText}>
                        {"Download the Lesson Materials"}
                        <br /> {"before beginning the Lesson"}
                      </div>
                    }
                    arrowPointAtCenter
                    color="#FFFFFF"
                  >
                    <IconOutline className={styles.infoIcon} width={19} />
                  </Tooltip>
                }
                rightIcon={
                  <IconArrowUp
                    className={[
                      styles.arrowIcon,
                      selectMaterial && selectedLessonId === lesson.id
                        ? styles.materialToggleClose
                        : styles.materialToggleOpen,
                    ].join(" ")}
                    width={13}
                  />
                }
                onClick={handleSelectMaterials}
              />
            </div>
          )}
          {isHomeEDApp && studyMode === ModeTypeEnum.Study ? (
            <>
              <div
                className={styles.statusTipView}
                style={{
                  display: completeRequire ? "flex" : "none",
                  right:
                    studyMode === ModeTypeEnum.Study && studyPlan
                      ? "-108px"
                      : "-78px",
                }}
              >
                <div
                  className={
                    studyMode === ModeTypeEnum.Study && studyPlan
                      ? styles.tipStudyTextView
                      : styles.tipTextView
                  }
                >
                  <div className={styles.tipTitle}>
                    {complete
                      ? studyMode === ModeTypeEnum.Study && studyPlan
                        ? `Mark ${studyPlan.name}'s Lesson as Incomplete`
                        : "Mark Lesson as Incomplete"
                      : isHomeEDApp &&
                          studyMode === ModeTypeEnum.Study &&
                          studyPlan
                        ? `Mark ${studyPlan.name}'s Lesson as Complete`
                        : "Mark Lesson as Complete"}
                  </div>
                </div>
                <div className={styles.arrowDown}></div>
              </div>
              <div className={styles.statusView}>
                {index === 0 ||
                lesson.status === LessonStatus.Confirmed ||
                lesson.status === LessonStatus.Completed ||
                preLesson?.status === LessonStatus.Confirmed ? (
                  <div
                    className={completedCheckStyle}
                    onClick={
                      lesson.status === LessonStatus.Completed
                        ? handleConfirmComplete
                        : (e) => e.stopPropagation()
                    }
                    onMouseOver={
                      false ? () => setCompleteRequire(true) : () => {}
                    }
                    onMouseLeave={() => setCompleteRequire(false)}
                  >
                    {loading ||
                    fetching ||
                    fetchingHea ||
                    heaLessonCompleteInProgress ? (
                      <LoadingOutlined
                        style={{ fontSize: 24, borderRadius: 15 }}
                        spin
                      />
                    ) : complete ? (
                      <>
                        <MarkCheckIcon
                          className={completeCheckIconStyle}
                          width={32}
                          height={32}
                        />
                        {/* <MarkCrossIcon className={styles.inCompletedCrossIcon} width={32} height={32}/> */}
                        <NormalCheckIcon
                          className={styles.inCompletedNormalIcon}
                          width={32}
                          height={32}
                        />
                      </>
                    ) : (
                      <>
                        {completeRequire ? (
                          <MarkCheckIcon
                            className={styles.completedCrossIcon}
                            width={32}
                            height={32}
                          />
                        ) : incompleted ? (
                          <>
                            <MarkCheckIcon
                              className={styles.reviewCheckIcon}
                              width={32}
                              height={32}
                            />
                            <NormalCheckIcon
                              className={styles.inCompletedNormalIcon}
                              width={32}
                              height={32}
                            />
                          </>
                        ) : (
                          <NormalCheckIcon
                            className={normalCheckIconStyle}
                            width={32}
                            height={32}
                          />
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  <div
                    className={styles.lockComplete}
                    onMouseOver={
                      index === 0 ||
                      preLesson?.status === LessonStatus.Confirmed
                        ? () => setCompleteRequire(true)
                        : () => {}
                    }
                    onMouseLeave={() => setCompleteRequire(false)}
                  >
                    {isHovered ? (
                      <CompleteLockRed width={41} height={56} />
                    ) : (
                      <CompleteLock width={41} height={56} />
                    )}
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <div
                className={styles.statusTipView}
                style={{
                  display: completeRequire ? "flex" : "none",
                  right:
                    isHomeEDApp && studyMode === ModeTypeEnum.Study && studyPlan
                      ? "-108px"
                      : "-78px",
                }}
              >
                <div
                  className={
                    isHomeEDApp && studyMode === ModeTypeEnum.Study && studyPlan
                      ? styles.tipStudyTextView
                      : styles.tipTextView
                  }
                >
                  <div className={styles.tipTitle}>
                    {complete
                      ? isHomeEDApp &&
                        studyMode === ModeTypeEnum.Study &&
                        studyPlan
                        ? `Mark ${studyPlan.name}'s Lesson as Incomplete`
                        : "Mark Lesson as Incomplete"
                      : isHomeEDApp &&
                          studyMode === ModeTypeEnum.Study &&
                          studyPlan
                        ? `Mark ${studyPlan.name}'s Lesson as Complete`
                        : "Mark Lesson as Complete"}
                  </div>
                </div>
                <div className={styles.arrowDown}></div>
              </div>
              <div className={styles.statusView}>
                <button
                  disabled={isLocked}
                  className={completedCheckStyle}
                  onClick={markLessonAsComplete}
                  onMouseOver={() => setCompleteRequire(true)}
                  onMouseLeave={() => setCompleteRequire(false)}
                >
                  {loading ||
                  fetching ||
                  fetchingHea ||
                  heaLessonCompleteInProgress ? (
                    <LoadingOutlined
                      style={{ fontSize: 24, borderRadius: 15 }}
                      spin
                    />
                  ) : complete ? (
                    <>
                      <MarkCheckIcon
                        className={styles.completeCheckIcon}
                        width={32}
                        height={32}
                      />
                      <MarkCrossIcon
                        className={styles.inCompletedCrossIcon}
                        width={32}
                        height={32}
                      />
                    </>
                  ) : (
                    <>
                      {completeRequire ? (
                        <MarkCheckIcon
                          className={styles.completedCrossIcon}
                          width={32}
                          height={32}
                        />
                      ) : (
                        <NormalCheckIcon
                          className={styles.normalCheckIcon}
                          width={32}
                          height={32}
                        />
                      )}
                    </>
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </Dropdown>
      {
        <>
          {lesson.materials && lesson.materials?.length > 0
            ? lessonMaterials
            : null}
          {index !== 0 && !prerequisite
            ? isHomeEDApp && studyMode === ModeTypeEnum.Study
              ? heStatusContent
              : statusContent
            : null}
          {index !== lessonCount - 1 && statusHoverContent}
        </>
      }
    </div>
  );
}

export default LessonForm;
